<div class="staff-page">
  <!-- Toolbar -->
  <div class="toolbar">
    <div class="search-box">
      <i class="bx bx-search"></i>
      <input
        type="text"
        placeholder="Search Staff..."
        [value]="searchTerm"
        (input)="onSearch($event)"
      />
    </div>

    <div class="right-controls">
      <div class="fnf-segmented fnf-segmented--compact" role="tablist">
        <button
          type="button"
          class="fnf-segment"
          [class.fnf-segment--active]="viewMode === 'list'"
          (click)="setViewMode('list')"
        >
          <i class="bx bx-list-ul" aria-hidden="true"></i> List
        </button>
        <button
          type="button"
          class="fnf-segment"
          [class.fnf-segment--active]="viewMode === 'grid'"
          (click)="setViewMode('grid')"
        >
          <i class="bx bx-grid-alt" aria-hidden="true"></i> Grid
        </button>
      </div>

      <button type="button" class="new-btn" (click)="addNewStaff()">
        <i class="bx bx-plus"></i>
        Add Staff
      </button>
    </div>
  </div>

  <!-- Status tabs -->
  @if (staffs?.length > 0) {
    <div class="staff-tabs">
      @for (tab of staffTabs; track tab.value) {
        <button
          type="button"
          class="staff-tab"
          [class.active]="selectedType === tab.value"
          (click)="filterStaffs(tab.value)"
        >
          {{ tab.label }}
          <span class="tab-count">{{ tabCount(tab.value) }}</span>
        </button>
      }
    </div>
  }

  @if (displayLoading) {
    <div
      class="d-flex flex-column align-items-center justify-content-center common-loading-container"
    >
      <div class="w-25 text-center">
        <img class="common-loading" src="assets/menu_loading.gif" alt="common loading" />
        <p class="common-loading-text">Loading staffs, please wait...</p>
      </div>
    </div>
  } @else if (staffs?.length > 0) {
    @if (viewMode === 'list') {
      <!-- Table view -->
      <div class="list-card">
        <div class="list-head list-row">
          <span class="col-staff">Staff</span>
          <span class="col-role">Role</span>
          <span class="col-contact">Contact No</span>
          <span class="col-shift">Shift Type</span>
          <span class="col-joined">Joined Date</span>
          <span class="col-actions">Actions</span>
        </div>

        @for (staff of visibleStaffs; track staff) {
          <div class="list-row">
            <div class="col-staff staff-cell">
              <img
                class="avatar_img"
                [src]="staff.img_path?.trim() || staff.avatar"
                (error)="onImageError($event)"
              />
              <div class="staff-text">
                <span class="staff-name">
                  {{ staff.first_name }}
                  @if (staff.isCurrentUser) {
                    <span class="you-tag">You</span>
                  }
                </span>
                <span class="staff-email">{{ staff.email }}</span>
              </div>
            </div>
            <span class="col-role">
              <span class="role-pill" [class]="'role-pill ' + roleTone(staff.user_role)">
                {{ roleLabel(staff.user_role) }}
              </span>
            </span>
            <span class="col-contact">{{ staff.phone_number | usPhone }}</span>
            <span class="col-shift">
              <span class="shift-pill" [class]="'shift-pill ' + shiftTone(staff.shift_type)">
                {{ shiftLabel(staff.shift_type) }}
              </span>
            </span>
            <span class="col-joined">{{ staff.joined_date | date: 'MMM d, y' }}</span>
            <span class="col-actions">
              <div class="btn-group custom-dropdown1">
                <button
                  type="button"
                  class="kebab-btn dropdown-toggle"
                  data-bs-toggle="dropdown"
                  data-bs-display="static"
                  aria-expanded="false"
                >
                  <i class="bx bx-dots-horizontal-rounded"></i>
                </button>
                <ul class="dropdown-menu dropdown-menu-lg-end">
                  <li>
                    <a class="dropdown-item type-option" (click)="addNewStaff(staff)">
                      <i class="bx bx-edit-alt"></i> Edit Staff
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item type-option" (click)="setPinStaff(staff)">
                      <i class="bx bx-lock"></i> Set PIN
                    </a>
                  </li>
                  @if (
                    !staff.is_deleted && staff.user_status == 'active' && canSuspendOrRemove(staff)
                  ) {
                    <li>
                      <a class="dropdown-item type-option" (click)="suspendStaffConfirm(staff)">
                        <i class="bx bx-user-x"></i> Suspend Staff
                      </a>
                    </li>
                  }
                  @if (staff.user_status == 'suspended') {
                    <li>
                      <a class="dropdown-item type-option" (click)="unSuspendStaffConfirm(staff)">
                        <i class="bx bx-user-check"></i> Unsuspend Staff
                      </a>
                    </li>
                  }
                  @if (!staff.is_deleted && canSuspendOrRemove(staff)) {
                    <li class="custom-line-top"></li>
                    <li>
                      <a
                        class="dropdown-item type-option delete-dropdown-item"
                        (click)="deleteStaffConfirm(staff)"
                      >
                        <i class="bx bx-trash"></i> Remove staff
                      </a>
                    </li>
                  }
                </ul>
              </div>
            </span>
          </div>
        }

        @if (visibleStaffs.length === 0) {
          <div class="list-row empty-row">No records found</div>
        }

        <div class="list-footer">
          <span>
            Showing {{ visibleStaffs.length }} {{ selectedType }}
            {{ visibleStaffs.length === 1 ? 'staff' : 'staff' }}
          </span>
        </div>
      </div>
    } @else {
      <!-- Card grid -->
      <div class="staff-grid">
        @for (staff of visibleStaffs; track staff) {
          <div class="staff-card">
            <div class="staff-card-top">
              <div class="btn-group custom-dropdown1 card-kebab">
                <button
                  type="button"
                  class="kebab-btn dropdown-toggle"
                  data-bs-toggle="dropdown"
                  data-bs-display="static"
                  aria-expanded="false"
                >
                  <i class="bx bx-dots-vertical-rounded"></i>
                </button>
                <ul class="dropdown-menu dropdown-menu-lg-end">
                  <li>
                    <a class="dropdown-item type-option" (click)="addNewStaff(staff)">
                      <i class="bx bx-edit-alt"></i> Edit Staff
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item type-option" (click)="setPinStaff(staff)">
                      <i class="bx bx-lock"></i> Set PIN
                    </a>
                  </li>
                  @if (
                    !staff.is_deleted && staff.user_status == 'active' && canSuspendOrRemove(staff)
                  ) {
                    <li>
                      <a class="dropdown-item type-option" (click)="suspendStaffConfirm(staff)">
                        <i class="bx bx-user-x"></i> Suspend Staff
                      </a>
                    </li>
                  }
                  @if (staff.user_status == 'suspended') {
                    <li>
                      <a class="dropdown-item type-option" (click)="unSuspendStaffConfirm(staff)">
                        <i class="bx bx-user-check"></i> Unsuspend Staff
                      </a>
                    </li>
                  }
                  @if (!staff.is_deleted && canSuspendOrRemove(staff)) {
                    <li class="custom-line-top"></li>
                    <li>
                      <a
                        class="dropdown-item type-option delete-dropdown-item"
                        (click)="deleteStaffConfirm(staff)"
                      >
                        <i class="bx bx-trash"></i> Remove staff
                      </a>
                    </li>
                  }
                </ul>
              </div>

              <img
                class="card-avatar"
                [src]="staff.img_path?.trim() || staff.avatar"
                (error)="onImageError($event)"
              />
              <span class="card-name">
                {{ staff.first_name }}
                @if (staff.isCurrentUser) {
                  <span class="you-tag">You</span>
                }
              </span>
              <span class="role-pill" [class]="'role-pill ' + roleTone(staff.user_role)">
                {{ roleLabel(staff.user_role) }}
              </span>
            </div>

            <div class="card-meta">
              <div class="info-row">
                <span class="info-label">Email</span>
                <span class="info-value ellipsis">{{ staff.email }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Contact No</span>
                <span class="info-value">{{ staff.phone_number | usPhone }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Shift Type</span>
                <span class="shift-pill" [class]="'shift-pill ' + shiftTone(staff.shift_type)">
                  {{ shiftLabel(staff.shift_type) }}
                </span>
              </div>
              <div class="info-row">
                <span class="info-label">Joined Date</span>
                <span class="info-value">{{ staff.joined_date | date: 'MMM d, y' }}</span>
              </div>
            </div>
          </div>
        }

        <!-- Invite tile -->
        <button type="button" class="invite-card" (click)="addNewStaff()">
          <span class="invite-plus"><i class="bx bx-plus"></i></span>
          <span class="invite-title">Invite New Staff</span>
          <span class="invite-sub">
            Add a team member to access and manage your Fork &amp; Find store
          </span>
        </button>
      </div>
    }
  } @else if (staffs?.length == 0) {
    <div
      class="d-flex flex-column align-items-center justify-content-center common-empty-container"
    >
      <img src="assets/no-orders-yet.svg" alt="No Staff" class="common-empty-img mb-3" />
      <p class="common-empty-header">No Staffs</p>
      <p class="common-empty-sub-text">Create staffs to manage your restaurant.</p>
    </div>
  }
</div>
